let mutations = {
  setPaymentOptions (state, data) {
    state.paymentOptions = data.paymentOptions
  },
  setPaymentMethods (state, data) {
    state.paymentMethods = data
  },
  setPaymentType (state, data) {
    state.paymentRequest.type = data
  },
  setPaymentAmount (state, data) {
    state.payableAmount = data
    state.paymentRequest.amount = data
  },
  setPaymentMethod (state, data) {
    state.paymentRequest.paymentMethod = data
  },
  setUserPromotionV3 (state, data) {
    state.userPromotionV3 = data
  },
  setMerchantsDashboard (state, data) {
    state.merchants = data
    let all = {
      categoryName: 'All',
      marketplaces: [],
      promotions: []
    }
    data.map(category => {
      all.marketplaces.push(...category.marketplaces)
      all.promotions.push(...category.promotions)
    })
    state.merchants.unshift(all)
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/eplNewDashboard/mutations.js